import { Box, Divider, FormControlLabel, Grid, Typography } from "@mui/material";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzSelectListPopupInput from "src/components/core-components/mui/inputs/ByzSelectListPopupInput";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";

const NurseConfirmationSection = () => {
  const { t } = useTranslate();
  return (
    <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2 }}>
      <Box sx={{ backgroundColor: "#63B4FF33", borderRadius: "8px", p: 1, mb: 2 }}>
        <Typography fontWeight={600} color="#2979C3">
          {t("safety-surgery.nurse-verification")}
        </Typography>
      </Box>
      <Typography variant="body2" fontWeight={500} mb={2}>
        {t("safety-surgery.note")}
      </Typography>
      <Grid container spacing={2} mb={2} sx={{ pl: 4 }}>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<ByzMuiCheckBox />}
            label={t("safety-surgery.informed-consent")}
            sx={{ gap: 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<ByzMuiCheckBox />}
            label={t("safety-surgery.confirmation-of-the-surgical")}
            sx={{ gap: 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<ByzMuiCheckBox />}
            label={t("safety-surgery.surgeon-made-mark")}
            sx={{ gap: 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}></Grid>
      </Grid>

      <Divider sx={{ borderColor: "black", borderBottomWidth: "2px", my: 2 }} />
      <Grid container spacing={2} alignItems="center" mb={2}>
        <Grid item xs={12} sm={4} display="flex" alignItems="center">
          <ByzMuiTypography isTitle sx={{ textAlign: 'left' }}>
            {t("safety-surgery.nurse-making-marking")}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <ByzSelectListPopupInput
            label={t("safety-surgery.operation.making-marking")}
            url=""
            displayField="name"
            sx={{ width: 220, height: 53 }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box sx={{ width: 220 }}>
            <ByzMuiDateTimePicker label={t("date")} value={new Date()} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NurseConfirmationSection;





